import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    maxLength: number = 18,
    options?: {
      preserveExtension?: boolean;
      spaceBeforeExt?: boolean;
    }
  ): string {
    if (!value) return '';

    const preserveExtension = options?.preserveExtension ?? true;
    const spaceBeforeExt = options?.spaceBeforeExt ?? false;

    if (!preserveExtension) {
      return value.length > maxLength ? `${value.slice(0, maxLength)  }...` : value;
    }

    const lastDotIndex = value.lastIndexOf('.');
    const hasExtension = lastDotIndex > 0 && lastDotIndex < value.length - 1;

    if (!hasExtension) {
      return value.length > maxLength ? `${value.slice(0, maxLength)  }...` : value;
    }

    const name = value.slice(0, lastDotIndex);
    const ext = value.slice(lastDotIndex);

    const separator = spaceBeforeExt ? ' ' : '';
    const reserved = 3 + separator.length + ext.length;

    const available = maxLength - reserved;
    if (available <= 0) return `...${  separator  }${ext}`;

    return name.length > available
      ? `${name.slice(0, available)  }...${  separator  }${ext}`
      : value;
  }
}
